






import { defineComponent } from '@nuxtjs/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';

export default defineComponent({
    mixins: [PageBuilderComponent],
    components: {
        PageBuilderComponent
    },
    props: {
        node: {
            type: Object,/** define type */
            required: true
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;

        const boxes = content.children[0].children.map(el => el.children).flat()

        return {
            content,
            boxes
        }
    },
})
